// removed by extract-text-webpack-plugin
module.exports = {"Package":"_30x9MB4WtghsdTLVGE6osi","Class":"_2AeNFfPjz_VhCLjhoey4ZJ","DesTable":"_3js4Vep_K1HuqpAE80AAuI","Left":"_1t2pXLVrAs-eA5EppwPvVL","Right":"_1_XCHgzfqu8RZSL50q_MlE","TableDiv":"_344txXjqOxqkDaFmFqkWVq","Table":"zXIcGYBCWHjm__m5vZ-ku","Clickable":"_3vvo8jXN8T8TYSpes3coaV","NewTitle":"_1Wmyoygl_jMr3NgJaK96yS","NoHomework":"_3IQuu5ELufGRNEpi2WVevA","Line":"ES0CDyVApoS99oPfH1HK-","Container":"_1muLxjqiQiEHp1oEv4EIjx","RecordDiv":"zv4VPyFFx51ve5ameZrRZ","Record":"_3XMpsDik2IVHxcYikPAZpX","BigRecord":"_2K0hQqlsO-ZGeQQsa4mB4C"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Homework/Homework.css
// module id = 378
// module chunks = 0